export type FillRandomValues = (target: Uint32Array<ArrayBuffer>) => void;

const UINT32_RANGE = 0x1_0000_0000;

function defaultFillRandomValues(target: Uint32Array<ArrayBuffer>): void {
  crypto.getRandomValues(target);
}

export function secureRandomInt(
  maxExclusive: number,
  fillRandomValues: FillRandomValues = defaultFillRandomValues,
): number {
  if (!Number.isSafeInteger(maxExclusive) || maxExclusive < 1 || maxExclusive > UINT32_RANGE) {
    throw new RangeError("maxExclusive must be an integer between 1 and 2^32");
  }

  const limit = Math.floor(UINT32_RANGE / maxExclusive) * maxExclusive;
  const buffer = new Uint32Array(1);
  do {
    fillRandomValues(buffer);
  } while ((buffer[0] ?? UINT32_RANGE) >= limit);

  return (buffer[0] ?? 0) % maxExclusive;
}

export function sampleWithoutReplacement<T>(
  items: readonly T[],
  count: number,
  fillRandomValues: FillRandomValues = defaultFillRandomValues,
): T[] {
  if (!Number.isSafeInteger(count) || count < 0) throw new RangeError("count must be a non-negative integer");
  const copy = [...items];
  const size = Math.min(count, copy.length);

  for (let index = 0; index < size; index += 1) {
    const swapIndex = index + secureRandomInt(copy.length - index, fillRandomValues);
    [copy[index], copy[swapIndex]] = [copy[swapIndex] as T, copy[index] as T];
  }

  return copy.slice(0, size);
}
